import actionTypes from '../constants/action-types';

export const toggleInfoModal = (show, type, message, translations, callback, path, btnText) => {
  return {
    type: actionTypes.TOGGLE_INFO_MODAL,
    data: {
      show,
      type,
      message,
      translations,
      callback,
      path,
      btnText,
    },
  };
};

export const toggleDefaultErrorModal = () => {
  return {
    type: actionTypes.TOGGLE_DEFAULT_ERROR_MODAL,
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/info-modal/actions/info-modal-actions.js